import { getPrivyPrimaryAddress } from '@/hooks';
import {
  primaryPrivateV2Api,
  privateV2Api,
} from '@/lib/api-clients/rest-client';
import { useAccountStore } from '@/store/use-account-store';
import { NotificationChannelStatus, NotificationChannelType } from '@/types';
import { usePrivy } from '@privy-io/react-auth';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type NotificationChannel = {
  channelId: string;
  destination: string;
  status: NotificationChannelStatus;
  type: NotificationChannelType;
  preferences: {
    isEnabled: boolean;
    notificationType: string;
  }[];
};

export type NotificationsSettings = {
  availableNotificationTypes: string[];
  channels: NotificationChannel[];
  success: boolean;
};

async function getNotifications() {
  return primaryPrivateV2Api.get<NotificationsSettings>(
    '/v2/notifications/settings',
  );
}

export const getNotificationsQueryKey = (
  primaryAddress: string | undefined,
) => ['/notifications/settings', primaryAddress];

export default function useNotifications() {
  const { user } = usePrivy();
  const address = getPrivyPrimaryAddress(user);
  const hasPrimaryAuth = useAccountStore((state) => state.hasPrimaryAuth);
  return useQuery({
    enabled: hasPrimaryAuth,
    queryKey: getNotificationsQueryKey(address),
    queryFn: () => getNotifications(),
  });
}
